import { PropsWithChildren } from 'react';
import { IntlProvider } from 'react-intl';

import { getMessagesForLocale } from 'features/intl/intlSlice';
import { DEFAULT_LOCALE } from 'helpers/consts';
import { flattenMessages } from 'helpers/intl/messages';
import { useUser } from 'selectors/userSelectors';

interface IMessages {
  [key: string]: string;
}

export default function ConnectedIntlProvider(props: PropsWithChildren) {
  const { children } = props;
  const { locale } = useUser();
  const messages = getMessagesForLocale(locale || DEFAULT_LOCALE);

  return (
    <IntlProvider
      locale={locale || DEFAULT_LOCALE}
      messages={flattenMessages(messages, '')}
    >
      {children}
    </IntlProvider>
  );
}
